const replacableRootPath = '{{rootPath}}';

export { replacableRootPath };
